<template>
    <div class="block-wizard">
      <div class="block-wizard__main field">
          <svg width="124" height="58" viewBox="0 0 124 58" xmlns="http://www.w3.org/2000/svg" stroke="#0D93D2">
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(44 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                </path>
              </g>
            </g>
            <text font-family="Arial-BoldMT, Arial" font-size="12" font-weight="bold" fill="#302D2D" stroke="none">
              <tspan x="0" y="54">{{ $t('survey.loadingInProgress') }}</tspan>
            </text>
          </svg>
      </div>
    </div>
</template>

<script>

const _ = require('lodash');

export default {
  name: 'Callback',
  async mounted() {
    if (_.get(this.$route, 'path') === '/callback/survey') {
      this.$router.push({
        name: 'Survey',
      });
    } else {
      this.$router.push({
        name: 'Home',
      });
    }
  },
};
</script>
